export const getters = {
  getBankAccount: state => state.bankAccount,
  getBankAccountLoadingStatus: state => state.bankAccountLoadingStatus,
  getDocuments: state => state.documents,
  getDocumentsLoadingStatus: state => state.documentsLoadingStatus,
  getFilingDecision: state => state.filingDecision,
  getFilingDecisionStatus: state => state.filingDecisionStatus,
  getCloseLoadingStatus: state => state.closeLoadingStatus,
  getProofFiles: state => state.proofFiles,
  getProofsLoadingStatus: state => state.proofLoadingStatus,
  getProofsUploaded: state => state.proofUploaded,
  getBackPermission: state => state.backToDecisionPermission,
};
